import { render, staticRenderFns } from "./MyDealsWidget.vue?vue&type=template&id=4cdb427e&scoped=true"
import script from "./MyDealsWidget.vue?vue&type=script&lang=js"
export * from "./MyDealsWidget.vue?vue&type=script&lang=js"
import style0 from "./MyDealsWidget.vue?vue&type=style&index=0&id=4cdb427e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdb427e",
  null
  
)

export default component.exports